import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    listHeader: {
      position: 'sticky',
      display: 'grid',
      marginRight: '8px',
      gridTemplateColumns: '215px 60px 60px 10px',
      gap: '12px',
      borderBottom: '1px solid #E0E0E0',
      top: 0,
      backgroundColor: '#ffffff',
      zIndex: 1,
      '& > *': {
        fontSize: '10px',
        fontWeight: 600,
        color: '#001D29',
        textAlign: 'center',
      },
    },
  }),
)
